import { render, staticRenderFns } from "./AssetMoreInfoItem.vue?vue&type=template&id=baa0efa2&"
import script from "./AssetMoreInfoItem.vue?vue&type=script&lang=js&"
export * from "./AssetMoreInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports